import { message } from 'antd'
import api from '../api/api'
import url from '../api/env'

const fileToBase64 = file => {
  if (file) {
    const contentType = `data:${file.type};base64,`

    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = readerEvt => {
        try {
          resolve(contentType + btoa(readerEvt.target.result))
        } catch (err) {
          reject(err)
        }
      }

      reader.readAsBinaryString(file)
    })
  }
}

const excludedChars = [
  '!',
  '$',
  '#',
  '%',
  '^',
  '&',
  '*',
  '+',
  '=',
  '{',
  '}',
  '‘',
  '|',
  '/',
  '?',
  '§',
  '`',
  '~',
  '¡',
  '™',
  '£',
  '¢',
  '∞',
  '¶',
  '•',
  'ª',
  'º',
  '–',
  '≠',
  '“',
  '’',
  'æ',
  '«',
  '≤',
  '≥',
  '÷',
  '±',
  "'",
  '"',
]

const validateEmail = email => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return re.test(String(email).toLowerCase()) && !excludedChars.some(char => email.indexOf(char) > -1)
}

const excludedCharsContent = (content) => {
  return excludedChars.some(char => content.indexOf(char) > -1)
}

const validateNit = nit => nit && String(nit).length > 0

const parseJwt = token => {
  if (!token || typeof token !== 'string') return

  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}
// retorna true si el JWT esta vigente y false si expiro
const checkJwtExpiration = (payload, preventTime = 30) => {
  if (!payload || !payload.exp) return

  const now = parseInt(Date.now() / 1000) // transforma de milisegundos a segundos

  return now < payload.exp - preventTime
}

const removeAccents = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

const camelCaseize = str => {
  if (typeof str !== 'string') return ''
  const charsArrOne = ["'", '|', '°', '¬', '!', '@', '·', '#', '$', '~', '%', '½', '&', '/', '(', ')']
  const charsArrTwo = ['=', '?', '\\', '¿', '¡', '¸', '+', '*', '´', '¨', '{', '}', '[', ']', '^', '`']
  const charsArrThree = ['-', '_', '.', ':', ',', ';', '─', '<', '>']
  const charsToRemove = charsArrOne.concat(charsArrTwo, charsArrThree)
  let result = removeAccents(str)
  // get rid charsToRemove
  result = result.split('').map(char => {
    if (charsToRemove.indexOf(char) > -1) return ' '
    return char
  })
  // set correct casing
  result = result
    .join('')
    .trim()
    .split(' ')
    .map((word, index) => {
      if (index === 0) return word.toLowerCase()
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })

  return result.join('').trim()
}

const felToFEL = (text) => {
  let result = text.trim()
    .split(' ')
    .map((word, index) => {
      if (word.toUpperCase() === 'FEL') return word.toUpperCase()
      return word.toLowerCase()
    })
  return result.join(' ').trim()
}

const getAge = date => {
  let birthday = new Date(date)
  let today = new Date()
  return parseInt((today - birthday) / (1000 * 60 * 60 * 24 * 365))
}

const clearForAuthError = () => {
  window.localStorage.clear()
  window.location.reload()
}

// get info for Commons services
const getCurrenciesOption = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.currencies_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.currencies_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getCountryOption = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.countries_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.countries_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getEnterpriseOption = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.companies_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.companies_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getEnterpriseOptionHonduras = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.companies_option_hondura}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.companies_option_hondura}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getStoreTypeOption = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.storeType_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.storeType_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getStoreChainOption = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.storeChain_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.storeChain_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getStoreFlag = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.storeFlag_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.storeFlag_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getLocation = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Location_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.Location_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getStoreFormat = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.storeFormat_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.storeFormat_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getSocioeconomicLevel = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.socioeconomicLevel_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.socioeconomicLevel_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getState = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.states_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.states_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getZone = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Zones_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.Zones_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getMunicipalities = async (filterName, stateId, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Municipality_options}?paginate0&name=%${encodeURIComponent(filterName)}%&state_id=${stateId}` : encodeURI(`${url.stage.Municipality_options}?paginate0&name=%${filterName}%&state_id=${stateId}`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getRegionsByCountryId = async (filterName, countryId, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Region}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%&country_id=${countryId}` : encodeURI(`${url.stage.Region}?sort_type=${sort_type}&per_page=100&name=%${filterName}%&country_id=${countryId}`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getStateByRegionId = async (filterName, regionId, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.states}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%&region_id=${regionId}` : encodeURI(`${url.stage.states}?sort_type=${sort_type}&per_page=100&name=%${filterName}%&region_id=${regionId}`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getMunicipalitiesByStateId = async (filterName, stateId, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Municipality}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%&state_id=${stateId}` : encodeURI(`${url.stage.Municipality}?sort_type=${sort_type}&per_page=100&name=%${filterName}%&state_id=${stateId}`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getZoneByMunicipalityId = async (filterName, stateId, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Zones_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%&state_id=${stateId}` : encodeURI(`${url.stage.Zones_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%&state_id=${stateId}`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getMakersOptions = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Makers}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.Makers}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getProductDepartamentOptions = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.ProductDepartament}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.ProductDepartament}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getProductCategoryOptions = async (filterName, stateId, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.ProductCategory}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%&product_department_id=${stateId}` : encodeURI(`${url.stage.ProductCategory}?sort_type=${sort_type}&per_page=100&name=%${filterName}%&product_department_id=${stateId}`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getStoreOption = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.stores_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.stores_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getStorsCagegory = async () =>
  api
    .get(`${url.stage.stores_category}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const datePreciosBD = async data =>
  api
    .post(`${url.stage.UpdatePricePresentation}`, data)
    .then(res => {
      return res
    })
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))
    
    const updateStatusCorrelative = async data =>
      api
        .post(`${url.stage.UpdatePricePresentation(data.store_id)}`, data)
        .then(res => {
          return res
        })
        .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))
        

const getStoreData = async store =>
  api
    .get(`${url.stage.data_changeprice(store)}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))
    
    

const getNextPage = async urlNextPage =>
  api
    .get(`${urlNextPage}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getCompanies = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.companies}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.companies}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getProductsOption = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.products}?sort_type=${sort_type}&per_page=30&description=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.products}?sort_type=${sort_type}&per_page=30&description=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getPresentationsOption = async (filterName, excludeChars, sort_type = true, company_id = '') =>
  api
    .get(excludeChars ? `${url.stage.Presentations_options}?presentation_description=%${encodeURIComponent(filterName)}%&${company_id}sku_code=%${encodeURIComponent(filterName)}%&per_page=30` : encodeURI(`${url.stage.Presentations_options}?presentation_description=%${filterName}%&${company_id}sku_code=%${filterName}%&per_page=30`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getUoms = async () =>
  api
    .get(`${url.stage.Uoms_options}?paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))


const getActPrinciple = async () =>
api
  .get(`${url.stage.ActivePrinciple}?paginate=0`, {})
  .then(res => res)
  .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))
  
  const getStoreChains = async () =>
    api
      .get(`${url.stage.storeChain_options}?paginate=0`, {})
      .then(res => res)
      .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))
    
const getUomsOption = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Uoms_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.Uoms_options}?sort_type=${sort_type}&per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const isEmpty = obj => {
  for (let key in obj) {
    if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
      return key
    }
  }
  return false
}

const isEmptyCombos = obj => {
  for (let key in obj) {
    if (obj[key] === '' || obj[key] === null || obj[key] === undefined || obj[key].length === 0) {
      return key
    }
  }
  return false
}

const isObjEmpty = obj => {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false
    }
  }
  return JSON.stringify(obj) === JSON.stringify({})
}

const getTurns = async (filterName, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Turns}?per_page=100&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.Turns}?per_page=100&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const getTurnsById = async (filterName, shopId, excludeChars, sort_type = true) =>
  api
    .get(excludeChars ? `${url.stage.Turns}?per_page=100&name=%${encodeURIComponent(filterName)}%&store_id=${shopId}` : encodeURI(`${url.stage.Turns}?per_page=100&name=%${filterName}%&store_id=${shopId}`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? clearForAuthError() : console.log(err)))

const formatDate = date => {
  let _date
  if (date) {
    _date = date.slice(0, 10).split('-').reverse().join('/')
  }
  return _date
}

const formatDateTime = (current_datetime) => {
  let formatted_date =
    rellenar(current_datetime.getDate())
    + "-"
    + rellenar((current_datetime.getMonth() + 1))
    + "-" + current_datetime.getFullYear()
    + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds();
  return formatted_date;
}

const rellenar = (value) => {

  if (value < 10) {
    return "0" + value.toString()
  }
  return value
}

const isAlphaNumeric = str => new RegExp(/^[A-Za-z0-9 ]*$/).test(str)

const formatNumber = number => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number)
}

function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

const validateNumber = number => !Number(number) || number.includes('.') || number.includes('-') || number.includes('+')
const validateQuantity = input => !input || isNaN(Number(input)) || Number(input) < 0
const validateNull = data => !data || data === '' || data.length === 0

const checkErrors = res => {
  Object.keys(res.errors).map(key => {
    switch (key) {
      case 'abbreviation':
        message.error(res.errors[key][0].replace('abbreviation', 'Abreviación'))
        break
      case 'name':
        message.error(res.errors[key][0].replace('name', 'Nombre'))
        break
      case 'nit':
        message.error(res.errors[key][0].replace('nit', 'NIT'))
        break
      case 'stock_count_id':
        message.error(res.errors[key][0].replace('stock count id', 'Conteo'))
        break
      case 'store_id':
        message.error(res.errors[key][0].replace('store id', 'Tienda'))
        break
      default:
        message.error(res.errors[key])
        break
    }
    return null
  })
}

const deepEqualCompare = (a, b) => {
  let keyA, keyB
  if (typeof a === 'object' && a !== null && typeof b === 'object' && b !== null) {
    var count = [0, 0]
    for (keyA in a) count[0]++
    for (keyB in b) count[1]++
    if (count[0] - count[1] !== 0) {
      return false
    }
    for (keyA in a) {
      if (!(keyA in b) || !deepEqualCompare(a[keyA], b[keyA])) {
        return false
      }
    }
    for (keyB in b) {
      if (!(keyB in a) || !deepEqualCompare(b[keyB], a[keyB])) {
        return false
      }
    }
    return true
  } else {
    return a === b
  }
}

const decimalAdjust = (value, exp, type = 'round') => {
  // Si el exp es indefinido o cero
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value)
  }
  value = +value
  exp = +exp
  // Si el valor no es un número o el exp no es un entero
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN
  }
  // Cambio
  value = value.toString().split('e')
  value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)))
  // Volver a cambiar
  value = value.toString().split('e')
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp))
}

const translatePaymentMethod = name => {
  let _name = name.toLowerCase()
  switch (_name) {
    case 'cash':
      _name = 'Efectivo'
      break
    case 'card':
      _name = 'Tarjeta'
      break
    case 'credit':
      _name = 'Crédito o vale'
      break
    case 'external services':
      _name = 'Servicios Externos'
      break
    default:
      break
  }
  return _name
}

export default {
  validateEmail,
  camelCaseize,
  checkJwtExpiration,
  clearForAuthError,
  getCurrenciesOption,
  getCountryOption,
  getEnterpriseOption,
  getEnterpriseOptionHonduras,
  getStoreTypeOption,
  getStoreChainOption,
  getStoreFlag,
  getLocation,
  getStoreFormat,
  getSocioeconomicLevel,
  getState,
  getZone,
  getMunicipalities,
  getNextPage,
  getRegionsByCountryId,
  getAge,
  getStateByRegionId,
  getMunicipalitiesByStateId,
  getZoneByMunicipalityId,
  getMakersOptions,
  getProductDepartamentOptions,
  getProductCategoryOptions,
  getStoreOption,
  getStorsCagegory,
  getStoreData,
  getUoms,
  isEmpty,
  getCompanies,
  getTurns,
  getProductsOption,
  getPresentationsOption,
  getUomsOption,
  getTurnsById,
  isAlphaNumeric,
  isEmptyCombos,
  isObjEmpty,
  parseJwt,
  removeAccents,
  datePreciosBD,
  formatDate,
  fileToBase64,
  formatNumber,
  jsUcfirst,
  validateNit,
  validateNumber,
  validateQuantity,
  validateNull,
  checkErrors,
  deepEqualCompare,
  decimalAdjust,
  translatePaymentMethod,
  formatDateTime,
  felToFEL,
  excludedCharsContent,
  getActPrinciple,
  getStoreChains,
  updateStatusCorrelative
}
